/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import IVno = Models.IVno;

    interface IAux {
        usersNo: number;
        admins: string;
        devicesNo: string;
        devicesOptions: {
            pageSize: number;
            sortType: string;
            sortDirection: string;
            searchText: string;
            currentPage: number;
            dataLoaded: boolean;
            moreDataAvailable: boolean;
        };
    }

    export class AdminVnosController {
        public static $name: string = "adminVnosController";
        public static $inject: string[] = ['vnoService',
                                           'userService',
                                           'ModalService',
                                           '$location',
                                           'networkNodeService',
                                           '$rootScope',
                                           '$scope',
                                          ];

        public vnos: (IVno & IAux)[];
        public users: Models.IUser[];

        private dataLoaded: boolean = false;
        private saving: boolean = false;
        private vnoObservable: Function = undefined;

        constructor(private vnoService: Services.VnoService,
                    private userService: Services.UserService,
                    private modalService: ngModal.IModalService,
                    private $location: ng.ILocationService,
                    private networkNodeService: Services.NetworkNodeService,
                    private $rootScope: ng.IRootScopeService,
                    private $scope: ng.IScope) {
            this.init();
            this.$scope.$on('$destroy', () => {
                if (this.vnoObservable !== undefined)
                    this.vnoObservable();
            });
            this.vnoObservable = this.$rootScope.$on(Services.VnoService.VNO_CHANGED, () => {
                this.init();
            });
        }

        public launchVnoModal(): void {
            this.modalService.showModal({
                templateUrl: Controllers.AdminVnoModalController.templateUrl,
                controller: Controllers.AdminVnoModalController.$name,
                inputs: {
                    title: 'Create VNO',
                    vno: {
                        id: undefined,
                        name: '',
                        owner: undefined,
                        description: '',
                    },
                    users: this.users,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.AdminVnoModalController.id,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((response: Controllers.IAdminVnoModalResponse) => {
                    this.saving = true;
                    modalElem.hide();
                    if (response !== undefined) {
                        if (response.existingUser === undefined)
                            this.createVnoWithNewUSer(response);
                        else
                            this.createVnoWithExistingUserHelper(response);
                    } else {
                        this.saving = false;
                    }
                });
            });
        }

        private async init(): Promise<void> {
            this.vnos = undefined;
            if ( await this.userService.userHasRolePromise('ROLE_ADMIN')) {
                this.vnoService.findAll().then((response: IVno[]) => {
                    this.vnos = response as ((IVno & IAux)[]);
                    this.dataLoaded = true;
                    for (let vno of this.vnos) {
                        vno.devicesOptions = {
                            pageSize: 10,
                            sortType: Models.NetworkNode.getDefaultOrderColumn(),
                            sortDirection: 'ASC',
                            searchText: '',
                            currentPage: 0,
                            dataLoaded: false,
                            moreDataAvailable: false,
                        };
                        this.loadNetworkNodesWithPageSize(vno, vno.devicesOptions.pageSize, 0).then(
                            () => {
                                //
                            });
                        vno.admins = '';
                        vno.adminUsers.map((user: Models.IUser) => {
                            if (user.username !== 'demiurgo')
                                vno.admins += vno.admins.length > 0 ? `, ${user.fullname}` : user.fullname;
                        });
                        vno.users = vno.users.filter((user: Models.IUser) => {
                            return user.username !== 'demiurgo';
                        });
                        vno.usersNo = vno.users.filter((user: Models.IUser) => {
                            return user.enabled;
                        }).length;
                    }
                });
                this.userService.findAll().then((response: Models.IUser[]) => {
                    this.users = response;
                    this.users.sort((user1: Models.IUser, user2: Models.IUser) => {
                        if (user1.fullname.toLowerCase() < user2.fullname.toLowerCase()) return -1;
                        if (user1.fullname.toLowerCase() > user2.fullname.toLowerCase()) return 1;
                        return 0;
                    });
                });
            } else if (await this.userService.userHasRolePromise('ORG_ADMIN_')) {
                this.$location.path(`/admin/vno/` + this.userService.getCurrentUser().organizationId);
            }
        }

        private loadNetworkNodesWithPageSize(vno: Models.IVno & IAux, pageSize: number, pageNumber: number): ng.IPromise<void> {
            return this.networkNodeService
                .getAllNetworkNodesByOrganizationId(vno.id, pageNumber, pageSize, vno.devicesOptions.sortType,
                    vno.devicesOptions.sortDirection, vno.devicesOptions.searchText)
                .then((networkNodes: Models.IPaginatedList<Models.NetworkNode>) => {
                    vno.devicesOptions.dataLoaded = true;
                    vno.devicesOptions.moreDataAvailable = (networkNodes.page.totalPages > (pageNumber + 1)) ? true : false;
                    vno.devices = networkNodes.elements;
                    (vno as Models.IVno & IAux).devicesNo =
                        vno.devicesOptions.moreDataAvailable ?
                            "" + networkNodes.page.size + "+" :
                            "" + networkNodes.page.totalElements;
                    // this controller does not manage the loadMore feature...
                });
        }

        private createVnoWithNewUSer(vnoAndUser: Application.Controllers.IAdminVnoModalResponse): void {
            this.vnoService.createVnoWithAdmin(vnoAndUser).then((newVno: Models.IVno) => {
                this.$location.path(`/admin/vno/` + newVno.id);
            }).catch((reason: ngCustom.IReason) => {
                this.modalService.showModal({
                    templateUrl: Controllers.ErrorModalController.templateURL,
                    controller: Controllers.ErrorModalController.$name,
                    inputs: {
                        title: 'Creating ',
                        description: reason.data.message,
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ErrorModalController.ID,
                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: Object) => {
                        modalElem.hide();
                    });
                });
            }).finally(() => {
                this.saving = false;
            });
        }

        private createVnoWithExistingUserHelper(vnoAndUser: Application.Controllers.IAdminVnoModalResponse): void {
            if (vnoAndUser.existingUser.organizationId) {
                this.vnoService.findById(vnoAndUser.existingUser.organizationId).then((currentVno: Models.Vno) => {
                    this.modalService.showModal({
                        templateUrl: Controllers.ConfirmModalController.templateURL,
                        controller: Controllers.ConfirmModalController.$name,
                        inputs: {
                            title: 'Change user VNO',
                            description: `The user currently belongs to ${currentVno.name} VNO. This user will be removed from the current
                                          VNO, and will be added to ${vnoAndUser.name} VNO instead. Do you wish to continue?`,
                            name: undefined,
                            type: 'information',
                        },
                    }).then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ConfirmModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                        modalElem.show();
                        modal.close.then((result: Object) => {
                            modalElem.hide();
                            if (result) {
                                this.createVnoWithExistingUser(vnoAndUser);
                            } else {
                                this.saving = false;
                                Common.Utils.alertOnInfo(`VNO Creation canceled.`, 'bottom-center');
                            }
                        });
                    });
                });
            } else {
                this.createVnoWithExistingUser(vnoAndUser);
            }
        }

        private createVnoWithExistingUser(vnoAndUser: Controllers.IAdminVnoModalResponse): void {
            let vno: IVno = new Models.Vno();
            vno.name = vnoAndUser.name;
            this.vnoService.createVno(vnoAndUser).then((newVno: IVno) => {
                this.vnoService.assignAdminToVno(vnoAndUser.existingUser, newVno).then((user: Models.IUser) => {
                        this.$location.path(`/admin/vno/` + newVno.id);
                    }).finally(() => {
                        this.saving = false;
                    });
            });
        }
    }
}
